export class ErrorFireModel{
    /**
     *
     */
    constructor() { 
        
    }
    ErrorID:number;
    ErrorDescription:string;
    ErrorNotice:string;
    ErrorSource:string; 
}